import React ,{useEffect} from 'react';
import AOS from 'aos';
import History from '../Components/Pages/Status/History';
import Key from '../Components/Pages/Status/Key';
import Tables from '../Components/Pages/Status/Tables';
import Header from '../Components/Shared/Header/Header';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function Status(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header styles="scrolled"/>
        <Tables />
        <Key />
        <History />
        <Start />
        <Footer/>
        </>
    )
};
export default Status ;